import React from 'react';

import {
  BorderStylingProps,
  DimensionStylingProps,
  MarginStylingProps,
  OverflowStylingProps,
  PaddingStylingProps,
} from '../../styling';

import { FlexContainer } from './FlexContainer';

interface FlexRowProps {
  children: React.ReactNode;
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  alignContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'stretch'
    | 'space-between'
    | 'space-around'
    | 'normal';
  gap?: string;
  dimensions?: DimensionStylingProps;
  overflow?: OverflowStylingProps;
  margin?: MarginStylingProps;
  padding?: PaddingStylingProps;
  border?: BorderStylingProps;
  style?: React.CSSProperties;
}

export const FlexRow = ({
  children,
  justifyContent,
  alignItems,
  alignContent,
  gap,
  dimensions,
  flexWrap,
  overflow,
  margin,
  padding,
  border,
  style,
}: FlexRowProps) => (
  <FlexContainer
    style={style}
    flexDirection="row"
    justifyContent={justifyContent}
    alignItems={alignItems}
    alignContent={alignContent}
    gap={gap}
    dimensions={dimensions}
    flexWrap={flexWrap}
    overflow={overflow}
    margin={margin}
    padding={padding}
    border={border}
  >
    {children}
  </FlexContainer>
);
